export const TITLE = 'pdp.pas.suggested_title';
export const VIEW_ALL = 'pdp.pas.suggested_view_all';
export const NO_SUGGESTIONS = 'pdp.pas.suggested_no_suggestions';
